export default __webpack_public_path__ + "static/test-tutorial-de-d7d33d667bac4cc8b6cde821a89f5265.mp4";